module.exports = __webpack_public_path__ + "img/peijianS.23bccd17.png";